"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgeWidget = void 0;
var tslib_1 = require("tslib");
var TableauUI = tslib_1.__importStar(require("@tableau/tableau-ui"));
var React = tslib_1.__importStar(require("react"));
var Declarative_1 = require("../../utils/Declarative");
/**
 * Badge is a static indicator that holds a small amount of information such as a condition, property, or some other metadata.
 *
 * All undocumented props will be passed to the root element.
 *
 * If a Badge is not surrounded by context-providing text, either `aria-label` or `aria-labelledby` must be provided for the element to be accessible.
 */
var BadgeWidget = function (props) {
    var testId = props.testId, badgeProps = tslib_1.__rest(props, ["testId"]);
    return React.createElement(TableauUI.Badge, tslib_1.__assign({ "data-tb-test-id": Declarative_1.makeTestId(testId, 'BadgeWidget') }, badgeProps));
};
exports.BadgeWidget = BadgeWidget;
exports.BadgeWidget.displayName = 'BadgeWidget';
//# sourceMappingURL=BadgeWidget.js.map